import { useFrontendConfigContext as Gt } from "../../../config-lib/contexts/FrontendConfigContext.js";
import "../../../config-lib/deserializes/yup/config.js";
import "../../../config-lib/graphql/getFrontendConfig.js";
import "@apollo/client";
import "../../../apostle-lib/deserializes/yup/apostle.js";
import { useState as d, useCallback as r, useEffect as S } from "react";
import * as s from "ramda";
import "../../util/i18n/helper/locale.js";
import { useTranslation as _t } from "react-i18next";
import { CurrencyTokenType as mt } from "../../../currency-lib/constants/currency.js";
import jt from "../../../currency-lib/hooks/graphql/useGetCurrencyInfo.js";
import Jt from "../../../currency-lib/hooks/graphql/useGetOffChainTokenBalances.js";
import { EmptyFullAccount as ft } from "../../constants/account.js";
import { ChainType as dt } from "../../constants/chain.js";
import { ERROR_CODE as qt } from "../../constants/error.js";
import { GASharedEventCategory as B, GASsoProviderMapping as Ht } from "../../constants/googleAnalytics.js";
import { LocalStorageKey as b } from "../../constants/storage.js";
import { useAdeptusContext as Kt } from "../adeptus/AdeptusContext.js";
import { useFingerPrintContext as $t } from "../fingerprint/FingerprintContext.js";
import { useLogicControlContext as zt } from "../share/LogicControlContext.js";
import { useMessageContext as Qt } from "../share/MessageContext.js";
import { CustomError as ut } from "../../errors/customError.js";
import Vt from "../../hooks/analytics/useGoogleTagManager.js";
import Xt from "../../hooks/errors/useErrorHandler.js";
import Yt from "../../hooks/generic/useChainSwitcher.js";
import Zt from "../../hooks/graphql/useBindWalletAddress.js";
import te from "../../hooks/graphql/useGetAccountDetail.js";
import ee from "../../hooks/graphql/useLoginByEmail.js";
import oe from "../../hooks/graphql/useLoginByOAuth.js";
import se from "../../hooks/graphql/useLoginByWallet.js";
import ne from "../../hooks/graphql/useLogout.js";
import ae from "../../hooks/graphql/useProcessEmailRegister.js";
import pt from "../../hooks/web3/useWeb3.js";
import { saveTokens as wt, saveChainType as re, cleanTokens as ie, cleanChainType as ce, getProvider as le, getAccessToken as x, getRefreshToken as me } from "../../util/authenication/index.js";
import { createStrictContext as fe } from "../../util/context/createStrictContext.js";
import { walletRdnsToType as de } from "../../util/wallet/walletRdnsToType.js";
import { getAccount as ue, watchAccount as pe } from "@wagmi/core";
import gt from "use-async-effect";
import { isAddress as we } from "viem";
import { jsx as ge } from "react/jsx-runtime";
const [he, so] = fe("Account"), no = (ht) => {
  const {
    children: yt
  } = ht, {
    cleanSession: M,
    correctNetwork: h,
    getBalances: D,
    walletInstalled: Ct,
    connectWallet: U
  } = pt(), {
    wagmiConfig: p
  } = pt(), {
    forceLogout: G,
    warnNetworkOnly: kt,
    setWarnNetworkOnly: y,
    setForceLogout: _
  } = zt(), {
    bindFingerPrint: j
  } = $t(), {
    waitConfig: J
  } = Gt(), {
    inviter: u,
    setWalletAddress: q,
    handleOnInviteSuccess: H
  } = Kt(), {
    t: W
  } = _t(), {
    detectWalletType: K
  } = Yt(), {
    getErrorMessage: $
  } = Xt(), {
    setInfo: z,
    showGeneralError: Q
  } = Qt(), {
    mutate: V
  } = Zt(), {
    mutate: X
  } = se(), {
    mutate: Y
  } = ee(), {
    mutate: Z
  } = ne(), {
    loginByOAuth: tt
  } = oe(), {
    fetch: I
  } = te(), {
    fetch: P
  } = jt(), {
    fetch: et
  } = Jt(), {
    mutate: ot
  } = ae(), [a, C] = d(ft), [m, N] = d(!1), [R, At] = d(!1), [st, nt] = d(null), [Tt, at] = d(null), [St, v] = d(!1), [It, Nt] = d(!1), [rt, it] = d(!1), {
    gtmEmitEvent: w,
    gtmConfigUserId: ct
  } = Vt(), lt = r(() => {
    C(ft);
  }, []), E = r((t) => {
    q(t || "");
  }, [q]), L = r(async (t) => {
    if (!t || !we(t))
      return null;
    const e = await D(t), {
      grouped: o
    } = await et(), n = await J();
    let i = {};
    const O = await P((n == null ? void 0 : n.supportToken.allTokens.onChain) || []), A = await P((n == null ? void 0 : n.supportToken.allTokens.offChain) || []);
    return s.isNotNil(i) && (s.forEach((l) => {
      const T = (l == null ? void 0 : l.type) || mt.Unspecified, F = s.assoc("amount", e[T] || "0", l);
      i = s.assoc(T, F, i);
    }, s.values(O || {})), s.forEach((l) => {
      const T = (l == null ? void 0 : l.type) || mt.Unspecified, F = s.assoc("amount", o[T] || "0", l);
      i = s.assoc(T, F, i);
    }, s.values(A || {}))), i;
  }, [D, et, J, P]), k = r(async (t) => {
    let e = s.clone(t);
    const o = await I();
    s.isNotNil(o) && (e = {
      ...o,
      accessToken: e.accessToken,
      refreshToken: e.refreshToken,
      walletDisplayMode: !0
    });
    const n = await L(e.walletAddress) || {};
    e = {
      ...e,
      balances: n,
      walletDisplayMode: !0
    }, C(e), ct(e.id);
  }, [I, ct, L]), c = r(async (t) => {
    t && (wt(t.accessToken, t.refreshToken), re(t.accessToken), j(), await k(t), E(t.walletAddress), N(!0), await h() || y(!0));
  }, [j, h, k, E, y]), f = r((t) => {
    if (u) {
      const e = s.propOr(!1, "new", t), o = s.pathOr("", ["invitation", "inviter"], t);
      if (e && !s.isEmpty(o)) {
        const n = s.pathOr("", ["invitation", "code"], u);
        s.isEmpty(n) || H();
      }
    }
  }, [H, u]), vt = r(async () => {
    if (!s.isNil(a == null ? void 0 : a.walletAddress) && !s.isEmpty(a == null ? void 0 : a.walletAddress)) {
      const t = await L(a.walletAddress) || {}, e = s.assoc("balances", t, a);
      C(e);
    }
  }, [a, L]), Et = r(async () => {
    const t = await I();
    s.isNil(t) || C({
      ...t,
      walletDisplayMode: !0
    });
  }, [I]), Lt = r(async () => {
    const t = await V(null), e = s.isNotNil(t);
    return e && (await c(t), await f(t)), e;
  }, [V, f, c]), Ot = r(async (t) => {
    try {
      const e = await ot({
        email: t.email,
        otpCode: t.otpCode,
        password: t.password,
        enableMarketingEvent: t.marketingMailOption,
        inviter: u
      });
      if (!e)
        throw new ut("cannot bind email", qt.ACCOUNT.BIND_EMAIL_FAIL);
      return z({
        message: W("account_setting.register_success"),
        confirm: W("common.popup.ok")
      }), await c(e), await f(e), e;
    } catch (e) {
      const o = $(e);
      return Q(o), null;
    }
  }, [ot, u, z, W, c, f, $, Q]), Bt = r(async (t, e) => {
    const {
      address: o
    } = await U({
      walletType: t,
      networkType: e
    }), n = await X({
      inviter: u,
      type: t,
      walletAddress: o
    });
    return w(n != null && n.new ? B.SignUp : B.Login, {
      label: "method",
      value: "wallet"
    }), await c(n), await f(n), n;
  }, [U, X, u, w, c, f]), Wt = r(async (t) => {
    const {
      email: e,
      password: o,
      geeTest: n
    } = t, i = await Y({
      email: e,
      password: o,
      geeTest: n
    });
    return w(B.Login, {
      label: "method",
      value: "email"
    }), await c(i), i;
  }, [Y, c, w]), Pt = r(async (t) => {
    const {
      authCode: e,
      network: o,
      invitationCode: n,
      redirectURI: i,
      appType: O
    } = t, A = await tt(O, o, i, e, n);
    return w(B.Login, {
      label: "method",
      value: Ht[O]
    }), await c(A), await f(A), A;
  }, [tt, w, c, f]), Rt = r((t) => {
    const e = localStorage.getItem(b.SsoState), o = JSON.parse(e || "{}");
    if (!o[t])
      throw new ut("invalid sso state");
    return o[t];
  }, []), Ft = r(({
    state: t,
    appType: e,
    redirectURI: o,
    currentUrl: n,
    purpose: i
  }) => {
    localStorage.setItem(b.SsoState, JSON.stringify({
      [t]: {
        appType: e,
        redirectURI: o,
        currentUrl: n,
        purpose: i
      }
    }));
  }, []), bt = r(() => {
    localStorage.removeItem(b.SsoState);
  }, []), xt = (a == null ? void 0 : a.chainType) === dt.Ronin || (a == null ? void 0 : a.chainType) === dt.RoninTestnet, g = r(() => {
    E(""), lt(), ie(), ce(), N(!1);
  }, [E, lt]), Mt = r(async () => {
    try {
      await Z();
    } finally {
      if (m) {
        const t = K();
        await M(t), g();
      }
    }
  }, [m, K, Z, M, g]), Dt = r((t) => {
    m ? t() : v(!0);
  }, [m]);
  gt(async () => {
    if (m) {
      const t = le();
      if (s.isNotNil(t) && !await Ct()) {
        at(t), it(!0);
        return;
      }
    }
    it(!0);
  }, []), gt(async () => {
    if (rt && s.isNotNil(x()))
      try {
        await k({
          accessToken: x(),
          refreshToken: me()
        });
        const t = s.isNotNil(p) ? ue(p) : null;
        t != null && t.isConnected && (await h() || y(!0));
      } catch (t) {
        console.warn(`cannot get address from metamask, reason: ${t.message}`);
      }
  }, [p, rt]), S(() => {
    const t = a.accessToken, e = x();
    if (t && !e) {
      const o = a.refreshToken;
      wt(t, o);
    }
    N(!!t || !!e);
  }, [a.accessToken]), S(() => {
    m && v(!1);
  }, [m]), S(() => {
  }, [g, st]), S(() => {
    G && (_(!1), g(), v(!0));
  }, [G, g, _]), S(() => {
    if (s.isNotNil(p)) {
      const t = pe(p, {
        async onChange(e, o) {
          if (e.isConnected !== R && At(e.isConnected), !o.isConnecting && e.isConnected && o.chainId !== e.chainId && !await h() && e.connector) {
            const i = de(e.connector.id);
            nt(i);
          }
          a.walletAddress && o.address && e.isDisconnected;
        }
      });
      return () => {
        t();
      };
    }
  }, [p, h, g, a, y, R]);
  const Ut = r(async () => {
    await k(a);
  }, [k, a]);
  return /* @__PURE__ */ ge(he, {
    value: {
      account: a,
      isLoggedIn: m,
      missWallet: Tt,
      showBindWalletPopup: It,
      showLoginPopup: St,
      warnNetworkOnly: kt,
      wrongNetwork: st,
      isRoninAccount: xt,
      isWalletConnected: R,
      bindWalletAddress: Lt,
      clearLocalSsoState: bt,
      fetchBalances: vt,
      fetchDetail: Et,
      loginByEmail: Wt,
      loginByOAuth: Pt,
      loginByWallet: Bt,
      logout: Mt,
      requireAuth: Dt,
      setAccount: C,
      setIsLoggedIn: N,
      setMissWallet: at,
      setShowBindWalletPopup: Nt,
      setShowLoginPopup: v,
      setWarnNetworkOnly: y,
      setWrongNetwork: nt,
      signUp: Ot,
      storeSsoState: Ft,
      verifyAndGetSsoState: Rt,
      refetchAccountDetail: Ut
    },
    children: yt
  });
};
export {
  no as AccountProvider,
  so as useAccountContext
};
//# sourceMappingURL=AccountContext.js.map
